export default __webpack_public_path__ + "static/media/home_web-sm@2x.17ba86f0.jpg";